import React from 'react';
import {Tag} from 'antd';

import fetch from '../fetch';
import utils from '../../utils';

import moment from 'moment';



const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback
}

const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}

const columns = utils.columns([
    {
        key:'$index', 
        label: '序号',
    },
    {
        key: 'submitEmployeeName',
        label: '录入人',
    },
    {
        key: 'objName',
        label: '诊改课程',
    },
    {
        key: 'resultState',
        label: '诊改状态',
        render: (val) => {
            if(val === 4) {
                return <Tag color='purple'>待处理或待审核</Tag>
            } else if(val === 5) {
                return <Tag color='red'>考核审核不通过</Tag>
            } else if(val === 6) {
                return <Tag color='green'>考核审核通过</Tag>
            }
        }
    },
    {
        key: 'targetName',
        label: '指标名称'
    },
    {
        key: 'submitTime',
        label: '录入时间'
    },
    {
        key: 'termName',
        label: '学期'
    },
])

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] !== '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('kczg/approval/examination/query?' + params.join('&'), keywords)
    .then((response) => {
        if(response.code === 200) {
            return response.payload.data;
        }
    }).then(data => (
        Object.assign({
            result: data.dataList || [],
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data || []).length ? '' : '暂无数据...'
        }))
    )
}

const getParents = (id, parents, row) => {
    if (parents.hasOwnProperty(id) === true) {
        return row.unshift(id), getParents(parents[id], parents, row);
    } else {
        return row.slice(1);
    }
}

const range = (start, stop) => {
    var result = [];
    for (stop; stop >= start; stop--) {
        result.push(stop);
    }

    return result;
}

const transform = (data) => {
    return data.map((d) => {
        var current = {
            label: d.label,
            key: d.id + '',
            value: d.id + '',
            //selectable: false
        };

        if(d.children) {
            current.children = transform(d.children);
        }
        return current;
    });
}

const codes = (data) => {
    const maps = {};
    data.forEach(d => {
        maps[d.id] = d.label;
    });

    return maps;
}

export default {
    columns,
    setRefresh,
    onSelect,
    getSelection,
    querySearch,
}